module.exports = __webpack_public_path__ + "img/g1.8d386b64.jpg";